import src from "IMAGE";
export default { src, width: 200, height: 50, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AKtCSrfRa3Lc2L293Ne4uNzYu7vc17i43Ni/vty0oqK3AKtBSbfRbnXc2MDA3Ne4uNzYvr3c2Lu73NnExNy0pKO3y28uEmwpqrsAAAAASUVORK5CYII="};
